module.exports = __webpack_public_path__ + "img/Support-skill-116.33a5b15e.png";